import {
  ArticleOutlined,
  CloudUpload,
  Send,
  SendAndArchive,
  SendRounded,
  Upload,
  UploadFile,
  UploadFileRounded,
  UploadSharp,
  VisibilityOutlined,
} from "@mui/icons-material";
import { Button, TextField } from "@mui/material";
import axios from "axios";
import Sidebar from "components/Sidebar/Sidebar";
import { useLayout } from "context/layout/layout";
import { useEffect, useState, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import config from "services/config";
import logo from "../../assets/white.png";
import { files } from "./files";

export const DTESender = () => {
  const params = useParams();
  const layout = useLayout();

  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [member, setMember] = useState({
    memberName: "",
    memberId: "",
    userId: "",
    email: "",
    available: 0,
  });

  const [viewMode, setViewMode] = useState("pdf"); // "pdf" or "template"
  const [selectedTemplate, setSelectedTemplate] = useState(files[0]);

  useEffect(() => {
    axios
      .post(
        `${config.url}/members/find`,
        { _id: params.memberId },
        { headers: { "Content-Type": "application/json" } }
      )
      .then(({ data }) => {
        setMember({
          ...member,
          ...data,
          memberId: params.memberId,
          memberName: data.name,
          available: data.freePass.available,
        });
        console.log(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // Clean up the object URL when component unmounts or when file changes
  useEffect(() => {
    return () => {
      if (fileUrl) {
        URL.revokeObjectURL(fileUrl);
      }
    };
  }, [fileUrl]);

  function handleEmail({ target: { value } }) {
    setMember({
      ...member,
      email: value,
    });
  }
  function handleUserId({ target: { value } }) {
    setMember({
      ...member,
      userId: value,
    });
  }

  const PRIMARY = "#4A90E2";
  const BACKGROUND = "#FFFFFF";
  const BORDER = "#E0E0E0";
  const TEXT = "#333333";
  const MUTED = "#777777";

  const [dragging, setDragging] = useState(false);
  const inputRef = useRef(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => setDragging(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const file = e.dataTransfer.files[0];
    processFile(file);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    processFile(file);
  };

  const processFile = (file) => {
    if (!file) return;

    // Create a URL for the file
    const url = URL.createObjectURL(file);

    // Update state
    setFile(file);
    setFileUrl(url);

    console.log("Archivo procesado:", file);
  };

  const toggleViewMode = () => {
    setViewMode(viewMode === "pdf" ? "template" : "pdf");
  };

  const handleTemplateChange = (event) => {
    const templateCode = event.target.value;
    const template = files.find((f) => f.code === templateCode);
    if (template) {
      setSelectedTemplate(template);
    }
  };

  const handleDTESend = async () => {
    if (!file) {
      alert("Por favor selecciona un archivo PDF primero");
      return;
    }
  
    if (!member.email) {
      alert("Por favor ingresa un email válido");
      return;
    }
  
    try {
      // Create form data
      const formData = new FormData();
      formData.append("file", file);
      formData.append("email", member.email);
      formData.append("memberId", member.memberId);
      formData.append("templateCode", selectedTemplate.code);
      
      // Show loading state
      // You could set a loading state here if desired
      
      // Send the request
      const response = await axios.post(
        `${config.url}/api/files/dte/upload/send`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }
      );
  
      // Handle success
      if (response.data.success) {
        alert("PDF enviado correctamente");
        // Reset form or redirect as needed
      } else {
        alert("Error al enviar el PDF: " + response.data.message);
      }
    } catch (error) {
      console.error("Error al enviar el archivo:", error);
      alert("Error al enviar el archivo. Por favor intenta de nuevo.");
    }
  };

  return (
    <div className="flex">
      <div className="flex w-1/2 justify-center">
        <img
          src={logo}
          style={{ width: 200, position: "absolute", top: -40 }}
        />
        <div
          className="flex flex-col justify-center items-center "
          style={{ minHeight: "100vh" }}
        >
          <div
            style={{
              maxWidth: 400,
              margin: "40px auto",
              padding: 20,
              background: BACKGROUND,
              borderRadius: 4,
              boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
              fontFamily: '"Helvetica Neue", Arial, sans-serif',
              color: TEXT,
              width: 400,
              marginTop: 100,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h2
              style={{
                fontSize: 18,
                fontWeight: 600,
                margin: 0,
                marginBottom: 8,
              }}
            >
              Subir PDF
            </h2>
            <p
              style={{
                fontSize: 14,
                margin: 0,
                marginBottom: 20,
                color: MUTED,
              }}
            >
              Selecciona o arrastra tu archivo PDF
            </p>

            <div
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              onClick={() => inputRef.current && inputRef.current.click()}
              style={{
                position: "relative",
                border: `2px dashed ${dragging ? PRIMARY : BORDER}`,
                borderRadius: 6,
                padding: "40px 20px",
                textAlign: "center",
                transition: "border-color 0.2s",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                marginBottom: 24,
                width: "100%",
                background: dragging ? "#F5FAFF" : BACKGROUND,
              }}
            >
              <CloudUpload sx={{ scale: 1.5 }} />
              <div
                style={{
                  fontSize: 14,
                  color: dragging ? PRIMARY : MUTED,
                  marginTop: 10,
                }}
              >
                Click o arrastra aquí
              </div>
              <input
                ref={inputRef}
                type="file"
                accept="application/pdf"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </div>

            <div className="relative w-full mb-4">
              <label style={{ fontSize: 12, color: "#fff" }}>
                Ingresa el correo del invitado
              </label>
              <TextField
                value={member.email}
                onChange={handleEmail}
                sx={{
                  padding: 0,
                  marginRight: 2,
                  border: "none",
                  background: "#fff",
                }}
                variant="outlined"
                type="text"
                className="rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              />
            </div>
            <button
              type="button"
              onClick={toggleViewMode}
              style={{
                width: "100%",
                padding: "12px 0",
                fontSize: 15,
                fontWeight: 600,
                color: "#FFF",
                background: PRIMARY,
                border: "none",
                borderRadius: 6,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                transition: "background 0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#417AC1")
              }
              onMouseLeave={(e) => (e.currentTarget.style.background = PRIMARY)}
            >
              {viewMode === "pdf" ? (
                <>
                  Ver Template <ArticleOutlined fontSize="small" />
                </>
              ) : (
                <>
                  Ver PDF <VisibilityOutlined fontSize="small" />
                </>
              )}
            </button>
            <Button onClick={handleDTESend} variant="outlined" className="mt-4">
              Enviar
            </Button>
          </div>
        </div>
      </div>
      <div className="flex w-1/2 justify-center ">
        <div
          className="flex flex-col justify-center items-center"
          style={{ minHeight: "100vh", width: "100%" }}
        >
          {viewMode === "pdf" ? (
            fileUrl ? (
              <iframe
                src={fileUrl}
                style={{
                  width: "100%",
                  height: "100vh",
                }}
                title="PDF Viewer"
              />
            ) : (
              <div style={{ color: MUTED, fontSize: 16 }}>
                Sube un PDF para visualizarlo aquí
              </div>
            )
          ) : (
            <iframe
              srcDoc={selectedTemplate.html}
              style={{ width: "100%", height: "100vh" }}
              title="Template Preview"
            />
          )}
        </div>
      </div>
    </div>
  );
};
